<template>
    <v-row dense>
        <v-col lg="6" md="6" sm="12" cols="12">
            <v-card
                flat
                tile
                :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'"
                class="my-profile"
            >
                <v-card-actions class="pl-5 align-start py-1">
                    <v-icon class="mt-4" color="#708AA7"
                        >mdi mdi-account-check-outline</v-icon
                    >
                    <v-card-text class="px-0 py-0">
                        <v-card-title class="text--green">{{
                            profile?.profileStatus
                        }}</v-card-title>
                        <v-card-subtitle class="edit"
                            >Go Client Portal to Verify</v-card-subtitle
                        >
                    </v-card-text>
                </v-card-actions>
            </v-card>
        </v-col>
        <v-col lg="6" md="6" sm="12" cols="12">
            <v-card
                flat
                tile
                :color="
                    $vuetify.theme.dark ? 'blue-darken-5' : 'white-lighten-1'
                "
                class="d-flex align-center justify-space-between my-profile"
            >
                <v-card-actions class="pl-5 align-start py-1">
                    <v-icon class="mt-4 ash-darken-2" color="ash-lighten-4"
                        >mdi mdi-seal-variant</v-icon
                    >
                    <v-card-text class="px-0 py-0">
                        <v-card-title class="text--green"
                            >{{ profile?.ibStatus }}

                            <v-tooltip top color="red-lighten-1">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        class="ml-2 ash-text-lighten-4"
                                        small
                                        color="#708AA7"
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        mdi mdi-information-outline
                                    </v-icon>
                                </template>
                                <span>Current IB Status</span>
                            </v-tooltip>
                        </v-card-title>
                        <v-card-subtitle>IB Status</v-card-subtitle>
                    </v-card-text>
                </v-card-actions>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import { PROFILE__ACTIONS } from "@/store/action-types";
import { mapState, mapActions } from "vuex";

export default {
    data() {
        return {};
    },

    computed: {
        ...mapState("profile", ["profile"]),
    },

    methods: {
        ...mapActions("profile", [PROFILE__ACTIONS.PROFILE]),
    },

    async mounted() {
        try {
            await this[PROFILE__ACTIONS.PROFILE]();
        } catch (error) {
            console.log(error);
        }
    },
};
</script>
